// extracted by mini-css-extract-plugin
export default {"container":"fsZ7OF"};